export enum BouncingDotsSize {
  XSMALL = 'xsmall',
  SMALL = 'small',
  MID = 'mid',
}
